/**
 * [CCI-15904] Meta key carried on a ProseMirror transaction that performs the final AI
 * streaming transformation (i.e. the commit of a single tool-call's content into the doc).
 *
 * The payload allows downstream plugins to:
 *   - know the exact doc range that was replaced (start/end positions in the new doc),
 *   - replay the change (newSlice) for "redo",
 *   - revert the change (originalUserContentSlice) for "undo",
 * without needing to inspect the transaction step-by-step.
 *
 * Set by `buildCommitTransaction` (only when the New AIFC Editor Experience gate is ON).
 * Consumed by the `aiSessionContextPlugin` to maintain `aiContentPositions`.
 */
import type { Slice } from '@atlaskit/editor-prosemirror/model';

export const AI_FINAL_STREAMING_TRANSFORMATION_DATA = 'aiFinalStreamingTransformationData';

export interface AIFinalStreamingTransformationData {
	newSlice: Slice;
	originalUserContentSlice: Slice;
	positions: {
		mappedStartPos: number;
		mappedToPos: number;
	};
}

/**
 * Meta on the terminal commit of a tool call force-finished by the queue timeout.
 * Set by `buildCommitTransaction` and consumed by `aiSessionContextPlugin.apply()`,
 * which records the final positions in `abortedToolCallPositions` for resume.
 */
export const CAPTURE_ABORTED_TOOL_CALL_POSITIONS = 'captureAbortedToolCallPositions';

export interface CaptureAbortedToolCallPositionsData {
	aiContentEndPos: number;
	startPos: number;
	toolCallId: string;
}
